const TYPING_DOT_STAGGER_SECONDS = 0.16;

export function TypingDots() {
  return (
    <span className='tw-flex tw-items-center tw-gap-0.75 tw-py-1' aria-hidden>
      {[0, 1, 2].map(dotIndex => (
        <span
          key={dotIndex}
          className='tw-inline-block tw-size-1 tw-animate-typing-dot-bounce tw-rounded-full tw-bg-current'
          style={{
            animationDelay: `${dotIndex * TYPING_DOT_STAGGER_SECONDS}s`,
          }}
        />
      ))}
    </span>
  );
}
